import { StrictMode, type ReactElement } from "react";
import { createRoot, type Root } from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import {
  getLocaleFromACULContext,
  i18next,
  initI18nPromise,
} from "@/i18n";

function ensureRootElement(): HTMLElement {
  const existing = document.getElementById("root");
  if (existing) return existing;
  const div = document.createElement("div");
  div.id = "root";
  document.body.appendChild(div);
  return div;
}

/** Boot i18n, sync language from ACUL context, render with react-i18next provider. */
export async function mountWithI18nProvider(tree: ReactElement): Promise<Root> {
  await initI18nPromise;
  await i18next.changeLanguage(getLocaleFromACULContext());
  const root = createRoot(ensureRootElement());
  root.render(
    <I18nextProvider i18n={i18next}>
      <StrictMode>{tree}</StrictMode>
    </I18nextProvider>,
  );
  return root;
}
